import constants from '../../../ahm-constants';
import liveChatConfig from '../../../utils/livechat';
import styles from '../components/support/styles.module.sass';

// @ts-expect-error - Automatic, Please fix when editing this file
const getSupportData = (actions) => [
  {
    className: styles.speechBubble1,
    onClick: () => actions.launch(liveChatConfig),
    title: 'message us',
  },
  {
    className: styles.speechBubble2,
    link: constants.URLS.SALES.CONTACT_US,
    subtitle: constants.CONTACT.PHONE.PRETTY,
    title: 'phone us',
  },
];

export default getSupportData;
